import { useEffect, useId, useRef } from "react";
import { useLocale } from "../../i18n/LocaleProvider";

export interface RequestEditorProps {
  note: string;
  onNoteChange: (text: string) => void;
  requestFocus: number;
}

/** One workflow request draft, shared by journal actions and report follow-ups. Locked while a turn runs. */
export function RequestEditor({ note, onNoteChange, requestFocus, disabled }: RequestEditorProps & { disabled: boolean }) {
  const { t } = useLocale();
  const id = useId();
  const input = useRef<HTMLTextAreaElement>(null);
  useEffect(() => {
    if (!requestFocus) return;
    input.current?.focus();
    input.current?.setSelectionRange(input.current.value.length, input.current.value.length);
  }, [requestFocus]);
  return <>
    <label htmlFor={id} className="end-report-note-label">{t("workSettings.currentRequest").replace(/[:：]$/, "")}</label>
    <textarea ref={input} id={id} value={note} disabled={disabled} maxLength={10000} onChange={(event) => onNoteChange(event.target.value)} />
  </>;
}

/** Journal actions can prepare a request before the first report is available. */
export function RequestPanel({ note, onNoteChange, requestFocus, disabled, onSubmit }: RequestEditorProps & {
  disabled: boolean;
  onSubmit: (note: string) => void;
}) {
  const { t } = useLocale();
  const formId = useId();
  return <aside className="work-settings-panel end-report-panel" aria-label={t("workSettings.currentRequest")}>
    <div className="work-settings-content"><div className="work-settings-body end-report-body">
      <form id={formId} className="end-report-next" onSubmit={(event) => {
        event.preventDefault();
        if (!disabled && note.trim()) onSubmit(note);
      }}>
        <RequestEditor note={note} onNoteChange={onNoteChange} requestFocus={requestFocus} disabled={disabled} />
      </form>
    </div></div>
    <footer className="work-settings-footer">
      <button type="submit" form={formId} className="btn primary" disabled={disabled || !note.trim()}>{t("endReport.continue")}</button>
    </footer>
  </aside>;
}
